import React from 'react';

const CategoryAnchorLinks = ({category}) => {
  const {
    copyOne,
    productsOne,
    copyTwo,
    productsTwo,
    copyThree,
    productsThree,
    copyFour,
    productsFour,
    copyFive,
    productsFive,
    copySix,
    productsSix,
    copySeven,
    productsSeven,
    copyEight,
    productsEight,
  } = category;

  const titleOne = copyOne?.value.split('|')[0];
  const titleTwo = copyTwo?.value.split('|')[0];
  const titleThree = copyThree?.value.split('|')[0];
  const titleFour = copyFour?.value.split('|')[0];
  const titleFive = copyFive?.value.split('|')[0];
  const titleSix = copySix?.value.split('|')[0];
  const titleSeven = copySeven?.value.split('|')[0];
  const titleEight = copyEight?.value.split('|')[0];

	const titles = [];
	if (titleOne && productsOne) {
		titles.push(titleOne);
	}
	if (titleTwo && productsTwo) {
		titles.push(titleTwo);
	}
	if (titleThree && productsThree) {
		titles.push(titleThree);
	}
	if (titleFour && productsFour) {
		titles.push(titleFour);
	}
	if (titleFive && productsFive) {
		titles.push(titleFive);
	}
	if (titleSix && productsSix) {
		titles.push(titleSix);
	}
	if (titleSeven && productsSeven) {
		titles.push(titleSeven);
	}
	if (titleEight && productsEight) {
		titles.push(titleEight);
	}

	const scrollToElement = (title) => {
		const modifiedTitle = title.split(' ').join('-').toLowerCase();
		const element = document.querySelector(`#${modifiedTitle}`);
		element.scrollIntoView({behavior: 'smooth', block: 'start'});
	};

	return (
		<div className="category-link-container">
			{titles.map(title => {
				const modifiedTitle = title.split(' ').join('-').toLowerCase();
				return (
					/* eslint-disable-next-line */
					<div className="category-anchor-link" onClick={() => scrollToElement(title)} id={`${ modifiedTitle }-button`}>
						<i className="gg-chevron-down" style={{display: 'inline'}} />
						<span className="title">
							<span>{title}</span>
						</span>
					</div>
				);
			})}
		</div>
	);
};

export default CategoryAnchorLinks;
